module.exports = __webpack_public_path__ + "static/procliq_logo_gray-4a8d1e71ddfc601c473c030f777b2b43.svg";